import { InspectionStatus } from 'shared/domain/inspection/inspectionModel';

export enum InspectionStatusSize {
  small = 'small',
  default = 'default',
  table = 'table',
}

export interface InspectionStatusProps {
  status: InspectionStatus;
  size?: InspectionStatusSize;
}
